import React, { useState, type FormEvent } from 'react';
import { NumberInput, RadioButtonGroupInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useRateCalculations } from '../hooks/useRateCalculations';

type Props = {
  source: string;
  inheritedSettings: any;
};

const choices = [
  { id: 'lock_charge_rate', name: 'Lock Charge Rate' },
  { id: 'lock_professional_rate', name: 'Lock Professional Rate' },
];

export const BaseMarginPercentW2LocalInput = ({ source, inheritedSettings }: Props) => {
  const [isLockOptionVisible, setIsLockOptionVisible] = useState(false);
  const { setValue } = useFormContext();
  const { watchedFields, handlers } = useRateCalculations({ source, inheritedSettings });

  function handleLockOptionChange(event: FormEvent<HTMLDivElement>) {
    const value = (event.target as HTMLInputElement).value as
      | 'lock_professional_rate'
      | 'lock_charge_rate';
    handlers.handleLockTypeChange(value);
  }

  return (
    <>
      <NumberInput
        source={`${source}.base_margin_percent_w2`}
        label="Base Margin Percent W2"
        onChange={(event) => {
          if (event.target.value === '') {
            setValue(`${source}.total_margin_percent_w2`, null);

            return;
          }

          const newValue = parseFloat(event.target.value);
          if (!isNaN(newValue)) {
            handlers.handleMarginChange(newValue);
          }
        }}
        onFocus={() => setIsLockOptionVisible(true)}
        helperText={String(inheritedSettings?.['base_margin_percent_w2'] || '')}
      />
      {isLockOptionVisible && (
        <RadioButtonGroupInput
          source={`${source}.lockedRateType`}
          choices={choices}
          value={watchedFields.lockedRateType}
          defaultValue="lock_charge_rate"
          label="Calculation Base"
          helperText="Select which rate will be fixed. The other will be automatically calculated based on the entered margin."
          onChange={handleLockOptionChange}
        />
      )}
    </>
  );
};
